export default __webpack_public_path__ + "static/media/team-pablo.cd38c814.webp";